<template>
    <div class="full-image-card hover-scale">
        <div class="image-div">
            <a href="#">
                <img 
                    :src="getImgUrl(team.photoUrl)"
                    :alt="team.name" 
                    class="img-fluid"
                />
            </a>
        </div>
        <div class="info-text-block">
            <h4>{{ team.name }}</h4>
            <p>{{ team.job }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "TeamCard",
    props: ["team"],
    methods: {
        getImgUrl(photoUrl) {
            return require("./../../assets/images/" + photoUrl);
        },
    }
}
</script>

<style scoped>
.full-image-card {
    margin-top: 60px;
}
.image-div {
    box-shadow: 0 3.4px 2.7px -30px rgba(0,0,0,.059), 0 8.2px 8.9px -30px rgba(0,0,0,.071), 0 25px 40px -30px rgba(0,0,0,.2);
    -webkit-border-radius: 8px;
    border-radius: 8px;
    position: relative;
    overflow: hidden;
}
.animation, a, .hover-scale img {
    transition: 1.2s cubic-bezier(.17,.85,.438,.99);
}
.hover-scale img {
    transform: scale(1.05);
    width: 100%;
}
.image-div img {
    width: 100%;
}
.img-fluid {
    max-width: 100%;
    height: auto;
}
.info-text-block {
    padding: 20px 0 0;
}
.info-text-block h4 {
    margin: 0 0 10px;
    color: #1f1f25;
    font-size: 22px;
    line-height: 32px;
}
.info-text-block p {
    font-size: 17px;
    line-height: 28px;
}
.hover-scale:hover img {
    transform: scale(1.1);
}
</style>